<template>
  <div
    class="py-4 px-2"
    style="display: flex; padding: 20px; height: 100%; overflow-y: auto"
  >
    <div style="flex: 1">
      <el-form
        :model="formData"
        :rules="formRules"
        label-width="1.3rem"
        ref="form"
        style="padding-bottom: 130px"
      >
        <el-form-item label="标题" required :rules="formRules.name" prop="name">
          <el-input v-model="formData.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item
          label="分类"
          required
          :rules="formRules.type_id"
          prop="type_id"
        >
          <el-select
            v-model="formData.type_id"
            placeholder="请选择"
            filterable
            clearable
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="上传视频"
          class="fjbox"
          style="display: flex; align-items: flex-start"
        >
          <el-upload
            class="upload-demo"
            :action="baseurl + '/api/login/upload'"
            :on-success="handleAvatarSuccess2"
            :on-remove="handleChange2"
            :show-file-list="false"
            :limit="1"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <div class="cp" @click="openUrl">{{ fileList.fullurl }}</div>
        </el-form-item>
        <el-form-item label="封面照片">
          <el-upload
            class="avatar-uploader"
            :action="baseurl + '/api/login/upload'"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="发布时间" required>
          <el-date-picker
            v-model="formData.fbtime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="排序">
          <el-input
            v-model="formData.weigh"
            type="number"
            placeholder="请输入"
            style="width: 202px"
          />
        </el-form-item>

        <div class="mt-16 pl-16" style="padding: 0 20px">
          <el-button type="primary" @click="onSubmit"> 保存 </el-button>
          <el-button type="info" @click="onCancel"> 取消 </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  components: {},
  data() {
    let that = this;
    return {
      baseurl: "",
      formDatalist: [], //其他新闻
      formData: {
        name: "",
        type_id: "",
        slturl: "",
        fbtime: "",
        qxtype: 2,
        spid: "",
      },
      imageUrl: "", //缩略图
      formRules: {
        name: [
          {
            required: true,
            message: "标题不能为空",
            whitespace: true,
          },
        ],
        type_id: [
          {
            required: true,
            message: "请选择视频分类",
          },
        ],
      },
      typeList: [], //类型

      id: 0,
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          that
            .$post({
              url: "/api/classify/index",
              params: {
                pid: node.level == 0 ? 0 : node.value,
                p: 1,
                size: 9999,
              },
            })
            .then((res) => {
              res.list = res.list.map((item) => ({
                value: item.id,
                label: item.name,
                leaf: item.ej.length > 0 ? false : true,
              }));
              resolve(res.list);
            });
        },
      },
      fileList: {},
    };
  },
  created() {
    this.baseurl = this.$URL;
    this.$post({
      url: "/api/xxpxtype/index",
      params: {},
    }).then((res) => {
      this.typeList = res.list;
    });
    if (this.$route.query.id) {
      this.getdetail();
    }
  },
  methods: {
    openUrl() {
      window.open(this.fileList.fullurl);
    },
    getdetail() {
      this.$post({
        url: "/api/Xxpx/details",
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        if (res.slturl.length > 0) {
          this.imageUrl = res.slturl[0].fullurl;
          res.slturl = res.slturl[0].id;
        }
        this.formData = res;
        if (res.spid.length > 0) {
          let fjlist = res.spid.map((item, index) => {
            let obj = {
              name: item.filename,
              fullurl: item.fullurl,
              id: item.id,
            };
            return obj;
          });
          this.fileList = fjlist[0];
        }
      });
    },
    handleAvatarSuccess2(res, file) {
      let obj = {
        name: res.file_name,
        fullurl: res.fullurl,
        id: res.id,
      };
      this.fileList = obj;
    },
    handleChange2(file, fileList) {
      this.fileList = fileList;
    },
    changejilian(e) {
      if (this.fenlei_ids.length >= 2) {
        //有二级
        this.formData.classify_id = this.fenlei_ids[1];
        this.formData.pid = this.fenlei_ids[0];
      } else {
        //没有二级
        this.formData.classify_id = this.fenlei_ids[0];
      }
    },
    onSubmit() {
      if (!this.formData.fbtime) {
        this.$message.warning("请选择发布时间");
        return;
      }
      if (this.fileList.id) {
        this.formData.spid = this.fileList.id;
      } else {
        this.$message.warning("请上传视频");
        return;
      }
      if (!this.formData.slturl) {
        this.$message.warning("请上传视频封面图片");
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(this.formData);
          this.$post({
            url: "/api/Xxpx/edit",
            params: this.formData,
          }).then((res) => {
            this.$message.success("操作成功");
            this.$router.go(-1);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.formData.slturl = res.id;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return isJPG && isLt2M;
    },
    onCancel() {
      this.$router.push("/system/xxpx");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .fjbox .el-form-item__content {
  margin-left: 0 !important;
}
::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #999;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 145px;
  height: 145px;
  line-height: 145px;
  text-align: center;
}

.avatar {
  width: 145px;
  height: 145px;
  display: block;
}

::v-deep .el-icon-circle-check:before {
  font-size: 0.2rem;
}

::v-deep .el-icon-circle-check {
  font-size: 0.2rem !important;
  line-height: 0.16rem;
  height: 0.16rem;
}

::v-deep .el-dialog__header {
  display: flex;
}

.filenamebox:hover {
  color: #409eff;
}
</style>
